import {palette} from "../common";

export default {
    styleOverrides: {
        root: {
            borderRadius: 6
        }
    }
}
